import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import bankList from '@/const/bank';
export default {
  meta: {
    title: '申请退保证金',
    auth: true,
    authorityValue: "store-store-bond-info"
  },
  name: 'returnBond',
  data: function data() {
    return {
      form: {
        payeeAccount: '',
        payeeAccountName: '',
        payeeBankName: '',
        payeeBankNo: ''
      },
      rules: {},
      options: [],
      record: {}
    };
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.$refs['form'].validate( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
                    var params;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!valid) {
                              _context.next = 6;
                              break;
                            }

                            params = _objectSpread({}, _this.form);
                            _context.next = 4;
                            return _this.$api.refundDeposit(params);

                          case 4:
                            _this.$notify.success({
                              title: '成功',
                              message: '提交申请'
                            });

                            _this.goBack();

                          case 6:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    dataBind: function dataBind(item) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this2.$api.cacheInfo();

              case 2:
                data = _context3.sent;
                _this2.form = _objectSpread(_objectSpread({}, _this2.form), data);
                _this2.options = bankList;
                _context3.next = 7;
                return _this2.$api.depositList();

              case 7:
                _this2.record = _context3.sent;

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  },
  created: function created() {
    this.dataBind();
  }
};